import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import cartReducer from './slices/cartSlice';
import notificationReducer from './slices/notificationSlice';
import paymentScheduleReducer from './slices/paymentScheduleSlice';
import quoteReducer from './slices/quoteSlice';
import bookingReducer from './slices/bookingSlice';
import vendorReducer from './slices/vendorSlice';
import menuReducer from './slices/menuSlice';
import leadReducer from './slices/leadSlice';
import wishlistReducer from './slices/wishlistSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    notifications: notificationReducer,
    paymentSchedule: paymentScheduleReducer,
    quotes: quoteReducer,
    bookings: bookingReducer,
    vendors: vendorReducer,
    menus: menuReducer,
    leads: leadReducer,
    wishlist: wishlistReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Export types for TypeScript usage (if needed)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
